<section class="mb-50.5">
  <app-reports-card [reportsData]="docReportsData"></app-reports-card>
</section>
<app-support-banner></app-support-banner>
<app-help-block [type]="'secondary'"></app-help-block>
